export default __webpack_public_path__ + "static/media/049.d00e159e.png";